export default "__VITE_ASSET__XoYiBsxY__"